import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { JobMatchesQueryFilter } from 'src/app/public/app/models/jobMatchesQueryFilter';
import { AuthService } from 'src/app/core/services/auth.service';
import { StateManagementStorageService } from 'src/app/core/services/state-management-storage.service';

@Component({
  selector: 'app-candidate-job-matches-workflow-page',
  templateUrl: './candidate-job-matches-workflow-page.component.html'
})
export class CandidateJobMatchesWorkflowPageComponent implements OnInit {

  @Input() $transition$: any;

  userId: any;
  jobId: any;
  reqStateData: any;
  globalQueryFilterObject: any;

  constructor(
    private authService: AuthService,
    private stateManagementStorageService: StateManagementStorageService
  ) { }

  ngOnInit() {
    const stateParams = this.$transition$.params();
    this.userId = this.authService.getUserDetails().id;
    this.jobId = stateParams.jobId == null ? '' : stateParams.jobId;
    this.reqStateData = stateParams.reqStateData == null ? '' : stateParams.reqStateData;
    this._setGlobalFilters(stateParams);
  }

  private _setGlobalFilters(stateParams: any) {
    const filter = new JobMatchesQueryFilter();
    const savedFilters = this.stateManagementStorageService.getScreenState(`candidateWorkflowScreen-${this.userId}`);
    if (savedFilters && !_.isEmpty(savedFilters)) {
      this.globalQueryFilterObject = _.cloneDeep(savedFilters);
      this.globalQueryFilterObject.jobMatchIds = [];
    } else {
      this.globalQueryFilterObject = new JobMatchesQueryFilter();
      this.stateManagementStorageService.setScreenState(`candidateWorkflowScreen-${this.userId}`, filter);
    }
    if (stateParams.searchString != null) {
      this.globalQueryFilterObject.searchString = stateParams.searchString;
    }
    if (stateParams.jobMatchId != null) {
      this.globalQueryFilterObject.jobMatchIds.push(stateParams.jobMatchId);
    }
    if (stateParams.visibilityFiltersObject != null) {
      this.globalQueryFilterObject.isUnassigned = (stateParams.visibilityFiltersObject.isUnassigned != null) && (stateParams.visibilityFiltersObject.isUnassigned);
      this.globalQueryFilterObject.isAssignedToOthers = (stateParams.visibilityFiltersObject.isAssignedToOthers != null) && (stateParams.visibilityFiltersObject.isAssignedToOthers);
      this.globalQueryFilterObject.isAssignedToMe = (stateParams.visibilityFiltersObject.isAssignedToMe != null) && (stateParams.visibilityFiltersObject.isAssignedToMe);
    } else {
      this.globalQueryFilterObject.isUnassigned = true;
      this.globalQueryFilterObject.isAssignedToOthers = true;
      this.globalQueryFilterObject.isAssignedToMe = true;
    }
  }
}
